export const getVaultEventsParameters = vaultState => {
  return {
    limit: vaultState.tableConfiguration.limit,
    offset: vaultState.tableConfiguration.offset,
  }
}
